import React, { useState } from "react";
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { AppSidebar } from "@/components/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/breadcrumb";
import { Separator } from "@/components/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/sidebar";
import { Button } from "@/components/button";
import { Card, CardContent } from "@/components/card";
import { Link } from "react-router-dom";
import {
  RiAndroidFill,
  RiAppleFill,
  RiWindowsFill,
  RiTelegramFill,
  RiDownloadLine,
  RiAddCircleLine,
  RiLoader4Line,
} from "@remixicon/react";
import {larissaChain} from "@/configs/chain";
import {mainConfig} from "@/configs/main.config";

// MetaMask Fox Icon Component
const MetaMaskIcon = ({ className = "size-8" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 318.6 318.6" xmlns="http://www.w3.org/2000/svg">
    <polygon fill="#E2761B" stroke="#E2761B" points="274.1,35.5 174.6,109.4 193,65.8" />
    <polygon fill="#E4761B" stroke="#E4761B" points="44.4,35.5 143.1,110.1 125.6,65.8" />
    <polygon fill="#E4761B" stroke="#E4761B" points="238.3,206.8 211.8,247.4 268.5,263 284.8,207.7" />
    <polygon fill="#E4761B" stroke="#E4761B" points="33.9,207.7 50.1,263 106.8,247.4 80.3,206.8" />
    <polygon fill="#E4761B" stroke="#E4761B" points="103.6,138.2 87.8,162.1 144.1,164.6 142.1,104.1" />
    <polygon fill="#E4761B" stroke="#E4761B" points="214.9,138.2 175.9,103.4 174.6,164.6 230.8,162.1" />
    <polygon fill="#E4761B" stroke="#E4761B" points="106.8,247.4 140.6,230.9 111.4,208.1" />
    <polygon fill="#E4761B" stroke="#E4761B" points="177.9,230.9 211.8,247.4 207.1,208.1" />
    <polygon fill="#D7C1B3" stroke="#D7C1B3" points="211.8,247.4 177.9,230.9 180.6,253 180.3,262.3" />
    <polygon fill="#D7C1B3" stroke="#D7C1B3" points="106.8,247.4 138.3,262.3 138.1,253 140.6,230.9" />
    <polygon fill="#233447" stroke="#233447" points="138.8,193.5 110.6,185.2 130.5,176.1" />
    <polygon fill="#233447" stroke="#233447" points="179.7,193.5 188,176.1 208,185.2" />
    <polygon fill="#CD6116" stroke="#CD6116" points="106.8,247.4 111.6,206.8 80.3,207.7" />
    <polygon fill="#CD6116" stroke="#CD6116" points="207,206.8 211.8,247.4 238.3,207.7" />
    <polygon fill="#CD6116" stroke="#CD6116" points="230.8,162.1 174.6,164.6 179.8,193.5 188.1,176.1 208.1,185.2" />
    <polygon fill="#CD6116" stroke="#CD6116" points="110.6,185.2 130.6,176.1 138.8,193.5 144.1,164.6 87.8,162.1" />
    <polygon fill="#E4751F" stroke="#E4751F" points="87.8,162.1 111.4,208.1 110.6,185.2" />
    <polygon fill="#E4751F" stroke="#E4751F" points="208.1,185.2 207.1,208.1 230.8,162.1" />
    <polygon fill="#E4751F" stroke="#E4751F" points="144.1,164.6 138.8,193.5 145.4,227.6 146.9,182.7" />
    <polygon fill="#E4751F" stroke="#E4751F" points="174.6,164.6 171.9,182.6 173.1,227.6 179.8,193.5" />
    <polygon fill="#F6851B" stroke="#F6851B" points="179.8,193.5 173.1,227.6 177.9,230.9 207.1,208.1 208.1,185.2" />
    <polygon fill="#F6851B" stroke="#F6851B" points="110.6,185.2 111.4,208.1 140.6,230.9 145.4,227.6 138.8,193.5" />
    <polygon fill="#C0AD9E" stroke="#C0AD9E" points="180.3,262.3 180.6,253 178.1,250.8 140.4,250.8 138.1,253 138.3,262.3 106.8,247.4 117.8,256.4 140.1,271.9 178.4,271.9 200.8,256.4 211.8,247.4" />
    <polygon fill="#161616" stroke="#161616" points="177.9,230.9 173.1,227.6 145.4,227.6 140.6,230.9 138.1,253 140.4,250.8 178.1,250.8 180.6,253" />
    <polygon fill="#763D16" stroke="#763D16" points="278.3,114.2 286.8,73.4 274.1,35.5 177.9,106.9 214.9,138.2 267.2,153.5 278.8,140 273.8,136.4 281.8,129.1 275.6,124.3 283.6,118.2" />
    <polygon fill="#763D16" stroke="#763D16" points="31.8,73.4 40.3,114.2 34.9,118.2 42.9,124.3 36.8,129.1 44.8,136.4 39.8,140 51.3,153.5 103.6,138.2 140.6,106.9 44.4,35.5" />
    <polygon fill="#F6851B" stroke="#F6851B" points="267.2,153.5 214.9,138.2 230.8,162.1 207.1,208.1 238.3,207.7 284.8,207.7" />
    <polygon fill="#F6851B" stroke="#F6851B" points="103.6,138.2 51.3,153.5 33.9,207.7 80.3,207.7 111.4,208.1 87.8,162.1" />
    <polygon fill="#F6851B" stroke="#F6851B" points="174.6,164.6 177.9,106.9 193.1,65.8 125.6,65.8 140.6,106.9 144.1,164.6 145.3,182.8 145.4,227.6 173.1,227.6 173.3,182.8" />
  </svg>
);

interface WalletOption {
  id: string;
  platform: string;
  description: string;
  icon: React.ReactNode;
  link?: string;
  action?: () => void;
  isMetaMask?: boolean;
}

export default function BlockchainWalletPage() {
  const [isAddingToMetaMask, setIsAddingToMetaMask] = useState(false);

  const handleAddToMetaMask = async () => {
    if (typeof window === "undefined") {
      console.error("Window is not defined");
      return;
    }

    const ethereum = (window as any).ethereum;

    if (!ethereum) {
      alert(
        "MetaMask is not installed. Please install MetaMask extension first.\n\nNetwork Details:\nNetwork Name: Larissa\nRPC URL: https://rpc.larissa.network\nChain ID: 9898\nCurrency Symbol: LRS\nBlock Explorer: https://scan.larissa.network"
      );
      return;
    }

    setIsAddingToMetaMask(true);

    try {
      console.log("Attempting to add Larissa network to MetaMask...");

      await ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: mainConfig.chainHexID,
            chainName: larissaChain.name,
            nativeCurrency: {
              name: larissaChain.nativeCurrency.name,
              symbol: larissaChain.nativeCurrency.symbol,
              decimals: larissaChain.nativeCurrency.decimals,
            },
            rpcUrls: larissaChain.rpcUrls.default.http,
            blockExplorerUrls: [larissaChain.blockExplorers.default.url],
          },
        ],
      });

      console.log("Larissa network added successfully!");
      alert("Larissa network has been successfully added to MetaMask!");
    } catch (error: any) {
      console.error("Error adding network to MetaMask:", error);

      if (error.code === 4001) {
        console.log("User rejected the request");
        alert("You rejected the request to add Larissa network to MetaMask.");
      } else if (error.code === -32602) {
        console.error("Invalid parameters:", error);
        alert("Invalid network parameters. Please contact support.");
      } else {
        console.error("Unknown error:", error);
        alert(`Failed to add Larissa network to MetaMask: ${error.message || "Unknown error"}`);
      }
    } finally {
      setIsAddingToMetaMask(false);
    }
  };

  const walletOptions: WalletOption[] = [
    {
      id: "android",
      platform: "Android",
      description: "Download the Larissa Wallet app for Android devices from Google Play Store",
      icon: <RiAndroidFill className="size-8" />,
      link: mainConfig.wallets.android,
    },
    {
      id: "ios",
      platform: "iOS",
      description: "Download the Larissa Wallet app for iPhone and iPad from the App Store",
      icon: <RiAppleFill className="size-8" />,
      link: mainConfig.wallets.ios,
    },
    {
      id: "windows",
      platform: "Windows",
      description: "Download the Larissa Wallet desktop application for Windows",
      icon: <RiWindowsFill className="size-8" />,
      link: mainConfig.wallets.windows,
    },
    {
      id: "telegram",
      platform: "Telegram Bot",
      description: "Access your Larissa Wallet directly through Telegram messenger",
      icon: <RiTelegramFill className="size-8" />,
      link: mainConfig.wallets.telegram,
    },
    {
      id: "metamask",
      platform: "MetaMask",
      description: "Add Larissa network to your MetaMask wallet with one click",
      icon: <MetaMaskIcon className="size-8" />,
      action: handleAddToMetaMask,
      isMetaMask: true,
    },
  ];

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="px-4 md:px-6 lg:px-8 @container">
          <div className="w-full max-w-6xl mx-auto">
            <header className="flex flex-wrap gap-3 min-h-20 py-4 shrink-0 items-center transition-all ease-linear border-b">
              <div className="flex flex-1 items-center gap-2">
                <SidebarTrigger className="-ms-1" />
                <div className="max-lg:hidden lg:contents">
                  <Separator
                    orientation="vertical"
                    className="me-2 data-[orientation=vertical]:h-4"
                  />
                  <Breadcrumb>
                    <BreadcrumbList>
                      <BreadcrumbItem className="hidden md:block">
                        <BreadcrumbLink asChild>
                          <Link to="/">Home</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                          <Link to="/blockchain">Blockchain</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbPage>Wallet</BreadcrumbPage>
                      </BreadcrumbItem>
                    </BreadcrumbList>
                  </Breadcrumb>
                </div>
              </div>
              <ConnectButton />
            </header>

            <div className="py-6">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-[#FF8A3C] mr-3"></div>
                <h1 className="text-3xl font-bold">Larissa Wallets</h1>
              </div>

              <p className="text-muted-foreground mb-8 max-w-3xl">
                Choose from multiple wallet options to securely store, send, and receive LRS tokens.
                Whether you prefer mobile, desktop, or browser-based solutions, we have you covered.
              </p>

              <div className="w-full max-w-xs h-1 bg-gradient-to-r from-[#FF8A3C] to-transparent mb-8 rounded-full"></div>

              <section className="mb-12">
                <div className="flex items-center mb-6">
                  <div className="w-1 h-6 bg-[#FF8A3C] mr-3"></div>
                  <h2 className="text-2xl font-bold">Available Wallets</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {walletOptions.map((wallet) => (
                    <Card
                      key={wallet.id}
                      className="relative overflow-hidden bg-sidebar border border-border hover:border-[#FF8A3C]/50 transition-all duration-300 h-full"
                    >
                      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF8A3C] to-[#FF8A3C]/70"></div>

                      <CardContent className="p-6 flex flex-col h-full">
                        <div className="mb-4 flex items-center">
                          <div className="w-16 h-16 rounded-lg bg-muted flex items-center justify-center">
                            <div className="text-[#FF8A3C]">{wallet.icon}</div>
                          </div>
                        </div>

                        <h3 className="text-xl font-semibold mb-3">{wallet.platform}</h3>

                        <p className="text-sm text-muted-foreground mb-6 flex-grow">
                          {wallet.description}
                        </p>

                        <div className="mt-auto">
                          {wallet.isMetaMask ? (
                            <Button
                              onClick={wallet.action}
                              disabled={isAddingToMetaMask}
                              className="w-full bg-[#FF8A3C] text-white hover:bg-[#E67020] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              {isAddingToMetaMask ? (
                                <>
                                  <RiLoader4Line className="size-5 animate-spin" />
                                  <span>Adding...</span>
                                </>
                              ) : (
                                <>
                                  <RiAddCircleLine className="size-5" />
                                  <span>Add to MetaMask</span>
                                </>
                              )}
                            </Button>
                          ) : (
                            <a
                              href={wallet.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block"
                            >
                              <Button className="w-full bg-white text-black hover:bg-[#FF8A3C]/10 border border-[#FF8A3C] transition-colors">
                                <RiDownloadLine className="size-5 text-[#FF8A3C]" />
                                <span>Download</span>
                              </Button>
                            </a>
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </section>

              <section className="mt-10 p-6 bg-sidebar border border-border rounded-lg">
                <h3 className="text-xl font-semibold mb-4 flex items-center">
                  <span className="w-1 h-6 bg-[#FF8A3C] mr-3 inline-block"></span>
                  Network Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="text-muted-foreground">Network Name:</span>
                    <span className="ml-2 font-medium">{larissaChain.name}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Chain ID:</span>
                    <span className="ml-2 font-medium">{larissaChain.id}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">RPC URL:</span>
                    <span className="ml-2 font-medium">{larissaChain.rpcUrls.default.http[0]}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Currency Symbol:</span>
                    <span className="ml-2 font-medium">{larissaChain.nativeCurrency.symbol}</span>
                  </div>
                  <div className="md:col-span-2">
                    <span className="text-muted-foreground">Block Explorer:</span>
                    <span className="ml-2 font-medium">{larissaChain.blockExplorers.default.url}</span>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
